import React, { useState } from "react";
import "./Deposite.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import With_Dep_Ammout_card from "../Common/Common_Component/With_Dep_Ammout_card/With_Dep_Ammout_card";
import Payment_Method_Cards from "../Common/Common_Component/Payment_Method_Cards/Payment_Method_Cards";
import SelectChannel from "./SelectChannel/SelectChannel";
import DepositAmount from "./DepositAmount/DepositAmount";
import Deposite_info_card from "./Deposite_info_card/Deposite_info_card";
import Deposite_History from "./Deposite_History/Deposite_History";
import Deposite_bar from "./Deposite_bar/Deposite_bar";
import No_data from "../Common/No_data/No_data";

function Deposite() {
  const [activeIndex, setActiveIndex] = useState(0);

  const cards = [
    {
      img:
        "/assets/images/withdraw_Deposite/Payment_Method_Cards/Unified_Upi.png",
      title: "UPI-QR",
    },
    {
      img: "/assets/images/withdraw_Deposite/Payment_Method_Cards/upi.png",
      title: "UPI X QR",
    },
    {
      img:
        "/assets/images/withdraw_Deposite/Payment_Method_Cards/paytm_Group.png",
      title: "E- Wallet",
    },
    {
      img: "/assets/images/withdraw_Deposite/Payment_Method_Cards/paytm.png",
      title: "Paytm X QR",
    },
    {
      img: "/assets/images/withdraw_Deposite/Payment_Method_Cards/usdt.png",
      title: "USDT-TRC20",
    },
  ];

  return (
    <div className="Deposite">
      <Common_white_header
        headingText={"Deposit"}
        historyTitle={"Deposit history"}
        historyLink={"/deposite-history"}
      />
      <div className="container">
        <With_Dep_Ammout_card />

        {/* Payment Methods */}
        {/* <Payment_Method_Cards
          cards={cards}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        /> */}

        {/* TAB CONTENT */}
        {/* <SelectChannel activeIndex={activeIndex} /> */}

        <DepositAmount activeIndex={activeIndex} />

        <Deposite_info_card activeIndex={activeIndex} />

        <Deposite_History />
      </div>

      {/* <Deposite_bar /> */}
    </div>
  );
}

export default Deposite;
